import * as ActionTypes from './index';

export function sendForgotPassword(payload) {
    return {
        type: ActionTypes.SEND_FORGOT_PASSWORD,
        payload: payload
    }
}

export function sendForgotPasswordSuccess(payload) {
    return {
        type: ActionTypes.SEND_FORGOT_PASSWORD_SUCCESS,
        payload: payload
    }
}

export function sendForgotPasswordFailed(payload) {
    return {
        type: ActionTypes.SEND_FORGOT_PASSWORD_FAILED,
        payload: payload
    }
}

export function getSessionExpirationDate(payload) {
    return {
        type: ActionTypes.GET_SESSION_EXPIRATION_DATE,
        payload: payload
    }
}

export function getSessionExpirationDateSuccess(payload) {
    return {
        type: ActionTypes.GET_SESSION_EXPIRATION_DATE_SUCCESS,
        payload: payload
    }
}

export function getSessionExpirationDateFail(payload) {
    return {
        type: ActionTypes.GET_SESSION_EXPIRATION_DATE_FAIL,
        payload: payload
    }
}

//action for changing the username and password in the login form of the loginForm component
export function changeUserAtLoginProperties(userProp, value) {
	return {
		type : ActionTypes.CHANGE_USER_AT_LOGIN_PROPERTIES,
		payload: {key: userProp, value: value}
	}
}

//action to appear and disappear the information dialog box in the loginForm component when the user hovers over the info icon
export function displayInfoDialogBox() {
	return {
		type: ActionTypes.DISPLAY_INFO_DIALOG_BOX
	}
}

//action that is called when the user fails to log in
export function displayRejectAuthDialogBox(payload) {
	return {
		type: ActionTypes.DISPLAY_REJECT_AUTH_DIALOG_BOX,
		payload
	}
}


//change the user state in trying to log in
export function requestToLogin(user) {
	return {
		type: ActionTypes.REQUEST_TO_LOGIN,
		payload: user
	}
}

//change the user state to logged in and save to the store the loggedInUser info
export function receiveLogInResponse(user) {
	return {
		type: ActionTypes.RECEIVE_LOG_IN_RESPONSE,
		payload: user
	}
}

export function receiveVersion(version) {
	return {
		type: ActionTypes.RECEIVE_VERSION,
		payload: version
	}
}


//action to logout
export function logout() {
	return {
		type: ActionTypes.LOGOUT
	}
}

//action to request the pending toba
export function requestToba(id) {
	return {
		type: ActionTypes.REQUEST_TOBA,
		payload: id
	}
}


//action to save in the store the fetched toba
export function receiveToba(toba) {
	return {
		type: ActionTypes.RECEIVE_TOBA,
		payload: toba
	}
}

//action that receives failed request fetch pending toba
export function failedToReceiveToba(response) {
	return {
		type: ActionTypes.FAILED_TO_RECEIVE_TOBA,
		payload: response
	}
}

//action to request the accept toba
export function requestAcceptToba(id) {
	return {
		type: ActionTypes.REQUEST_ACCEPT_TOBA,
		payload: id
	}
}

//action that receives failed request accept toba
export function failedToAcceptToba(response) {
	return {
		type: ActionTypes.FAILED_TO_ACCEPT_TOBA,
		payload: response
	};
}

//action to save in the store the fetched accept toba
export function receiveAcceptToba(response) {
	return {
		type: ActionTypes.RECEIVE_ACCEPT_TOBA,
		payload: response
	}
}


//action to unset the display toba
export function displayToba(){
	return {
		type: ActionTypes.DISPLAY_TOBA
	}
}

//action that changes the user state settings
export function changeUserStateSettings(key, value) {
	return {
		type: ActionTypes.CHANGE_USER_STATE_SETTINGS,
		payload: {
			key,
			value
		}
	}
}

export function unlockAragUser(payload) {
	return {
		type: ActionTypes.UNLOCK_ARAG_USER,
		payload: payload
	}
}

export function unlockAragUserSuccess(payload) {
	return {
		type: ActionTypes.UNLOCK_ARAG_USER_SUCCESS,
		payload: payload
	}
}

export function unlockAragUserFailed(payload) {
	return {
		type: ActionTypes.UNLOCK_ARAG_USER_FAILED,
		payload: payload
	}
}